import {ITriviaContestHistory} from "apps/BWW_TRIVIA/modules/reducers/contests_history_trivia";
import {ITriviaStore} from "apps/BWW_TRIVIA/modules/types/store";
import {conforms, filter, find, findLast, includes, uniqBy} from "lodash";
import {getMonthAndYearOfDate} from "modules/utils/date";
import {EnumTriviaContestStatus} from "modules/utils/enums";
import moment from 'moment';
import {createSelector} from "reselect";


export const getTriviaContestsHistoryCommon = (store: ITriviaStore) => store.contests_history_trivia;

export const getContestsHistoryDates = createSelector(
	[getTriviaContestsHistoryCommon],
	(contests) => {
		return uniqBy(contests, (contest) => {
			return getMonthAndYearOfDate(contest.start_date_time)
		})
	}
);

export const getNightHistoryContests = createSelector(
	[getTriviaContestsHistoryCommon],
	(contests) => (format: string) => {
		const by_date_contests = uniqBy(contests, (contest) => {
			return moment(contest.start_date_time).format(format)
		});

		return filter(by_date_contests, ({status, is_herd}) => {
			return status !== EnumTriviaContestStatus.voided && is_herd
		})
	}
);


export const getContestsHistoryByYearMonth = createSelector(
	[getContestsHistoryDates],
	(contests) => (year: number, month: number) => {
		if ( month < 1 || month > 12 ) {
			return undefined;
		}

		return find(contests, (contest) => {
			return moment(contest.start_date_time).format('YYYY-M') === `${year}-${month}`;
		});
	}
);

export const getContestById = createSelector(
	[getContestsHistoryDates],
	(contests) => (id: number) => {
		return find(contests, {id})
	}
);

export const getLastGameNightHistoryContest = createSelector(
	[getTriviaContestsHistoryCommon],
	(contests: ITriviaContestHistory[]) => {
		return findLast(contests, conforms({
			status: (v: EnumTriviaContestStatus) => includes(
				[
					EnumTriviaContestStatus.live,
					EnumTriviaContestStatus.complete
				], v),
			is_herd: Boolean
		}));
	}
);